import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { DTypeForm } from '@grupo-constant/next-dtype/form';

@Component({
    selector: 'dtype-details',
    templateUrl: './dtype-details.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeDetailsComponent {

    @Input() dtypeForm: DTypeForm;
    @Input() isUpdate = false;

    constructor() { }

}
